/**
 * iter-386u-ao — Frontend hooks for the centralized PlanPermissions +
 * Module Visibility endpoints. Any button can gate itself on a capability
 * flag; any sidebar can hide items based on nature-of-business modules.
 */
import { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '@/App';

const _authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

export function usePlanPermissions() {
  const [state, setState] = useState({ plan_code: 'free', permissions: {}, loaded: false });
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/plan/permissions`, { headers: _authHeaders() });
        if (!cancelled) setState({ ...r.data, loaded: true });
      } catch { if (!cancelled) setState((p) => ({ ...p, loaded: true })); }
    })();
    return () => { cancelled = true; };
  }, []);
  const can = (capability) => Boolean(state.permissions?.[capability]);
  return { ...state, can };
}

export function useModuleVisibility() {
  const [state, setState] = useState({ nature_key: 'interior_design', modules: {}, loaded: false });
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/tenant/module-visibility`, { headers: _authHeaders() });
        if (!cancelled) setState({ ...r.data, loaded: true });
      } catch { if (!cancelled) setState((p) => ({ ...p, loaded: true })); }
    })();
    return () => { cancelled = true; };
  }, []);
  const isVisible = (moduleKey) => state.modules?.[moduleKey] !== false;
  return { ...state, isVisible };
}

// Fix 4: per-user module access matrix (owner-managed).
export const PATH_MODULE = {
  '/': 'dashboard', '/leads': 'leads', '/reports': 'reports', '/projects': 'projects', '/tasks': 'tasks',
  '/calendar': 'calendar', '/gantt': 'gantt', '/admin/activities': 'vendor_activities', '/boq-worksheets': 'boq',
  '/running-bills': 'running_bills', '/quotations': 'quotations', '/project-accounts': 'project_accounts',
  '/documents': 'documents', '/payments': 'payments', '/users': 'users', '/settings/notifications': 'notification_preferences',
  '/estimators/kitchen': 'kitchen_estimator', '/estimators/wardrobe': 'storage_estimator', '/products': 'products',
  '/materials': 'materials', '/settings/boq-categories': 'boq_categories', '/settings/ai-presets': 'ai_presets',
};

export function useModuleAccess() {
  const [state, setState] = useState({ managed: false, modules: {}, loaded: false });
  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await axios.get(`${API}/users/me/module-access`, { headers: _authHeaders() });
        if (!cancelled) setState({ ...r.data, loaded: true });
      } catch { if (!cancelled) setState((p) => ({ ...p, loaded: true })); }
    })();
    return () => { cancelled = true; };
  }, []);
  const allows = (moduleKey) => !state.managed || !moduleKey || state.modules?.[moduleKey] === true;
  return { ...state, allows };
}
